<script>
import { computed } from 'vue';

import { LpProgressCircle } from '@thehotelsnetwork/lampo';

import useSectionState from '@/state/useSectionState';

import Loader from '@/components/Loader/Loader.vue';

export default {
  components: {
    Loader,
    LpProgressCircle,
  },
  setup() {
    // state
    const { sectionScore, isSummarySection } = useSectionState();

    const isValidScore = computed(() => typeof sectionScore.value.score === 'number');

    const tpConfig = {
      type: 'info',
      content: { text: 'Score that compares your performance to your Proximity and THN Network compset. View to last 30 days' },
      preferred: ['right'],
    };

    return {
      sectionScore,
      isValidScore,
      isSummarySection,
      tpConfig,
    };
  },
};
</script>

<template>
  <div
    v-if="!sectionScore.error"
    class="flex ml-4"
  >
    <Loader
      v-if="sectionScore.loading"
      :size="'medium'"
    />
    <!-- score circle container -->
    <template
      v-else-if="isValidScore"
    >
      <LpProgressCircle
        v-tooltip="tpConfig"
        :value="sectionScore.score"
        :size="'small'"
        animate
      />

      <!-- logo -->
      <div
        v-if="isSummarySection"
        class="h-5 m-1 text-black"
      >
        <img
          class="h-full"
          src="@/assets/img/logo/dbi-logo.svg"
          alt="dbi-logo"
        >
      </div>
    </template>
  </div>
</template>
